var map = {
	"./ion-action-sheet.entry.js": [
		7,
		7
	],
	"./ion-alert.entry.js": [
		2517,
		2517
	],
	"./ion-app_8.entry.js": [
		419,
		419
	],
	"./ion-avatar_3.entry.js": [
		5508,
		5508
	],
	"./ion-back-button.entry.js": [
		8205,
		8205
	],
	"./ion-backdrop.entry.js": [
		3389,
		3389
	],
	"./ion-button_2.entry.js": [
		6166,
		6166
	],
	"./ion-card_5.entry.js": [
		301,
		301
	],
	"./ion-checkbox.entry.js": [
		462,
		462
	],
	"./ion-chip.entry.js": [
		5325,
		5325
	],
	"./ion-col_3.entry.js": [
		7927,
		7927
	],
	"./ion-datetime_3.entry.js": [
		9136,
		9136
	],
	"./ion-fab_3.entry.js": [
		9632,
		9632
	],
	"./ion-img.entry.js": [
		1776,
		1776
	],
	"./ion-infinite-scroll_2.entry.js": [
		532,
		532
	],
	"./ion-input.entry.js": [
		3827,
		3827
	],
	"./ion-item-option_3.entry.js": [
		2358,
		2358
	],
	"./ion-item_8.entry.js": [
		9835,
		9835
	],
	"./ion-loading.entry.js": [
		8211,
		8211
	],
	"./ion-menu_3.entry.js": [
		4318,
		4318
	],
	"./ion-modal.entry.js": [
		9898,
		9898
	],
	"./ion-nav_2.entry.js": [
		4319,
		4319
	],
	"./ion-popover.entry.js": [
		9106,
		9106
	],
	"./ion-progress-bar.entry.js": [
		5100,
		5100
	],
	"./ion-radio_2.entry.js": [
		141,
		141
	],
	"./ion-range.entry.js": [
		8254,
		8254
	],
	"./ion-refresher_2.entry.js": [
		4654,
		4654
	],
	"./ion-reorder_2.entry.js": [
		5053,
		5053
	],
	"./ion-ripple-effect.entry.js": [
		3015,
		3015
	],
	"./ion-route_4.entry.js": [
		8573,
		8573
	],
	"./ion-searchbar.entry.js": [
		4802,
		4802
	],
	"./ion-segment_2.entry.js": [
		1495,
		1495
	],
	"./ion-select_3.entry.js": [
		1689,
		1689
	],
	"./ion-slide_2.entry.js": [
		803,
		803
	],
	"./ion-spinner.entry.js": [
		4818,
		4818
	],
	"./ion-split-pane.entry.js": [
		7653,
		34
	],
	"./ion-tab-bar_2.entry.js": [
		5677,
		5677
	],
	"./ion-tab_2.entry.js": [
		4533,
		4533
	],
	"./ion-text.entry.js": [
		2560,
		2560
	],
	"./ion-textarea.entry.js": [
		5381,
		5381
	],
	"./ion-toast.entry.js": [
		4316,
		4316
	],
	"./ion-toggle.entry.js": [
		6367,
		6367
	],
	"./ion-virtual-scroll.entry.js": [
		4860,
		4860
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3111;
module.exports = webpackAsyncContext;